import type { BusinessNumberState } from '@repo/api-contracts';
import { useRef, useState } from 'react';
import { trpc } from '@/shared/api';

/** 조회한 번호·요청 세대가 현재 입력과 일치하는 응답만 표시한다. */
export const useCheckBusinessNumber = (businessNumber: string) => {
  const mutation = trpc.taxInvoices.checkBusinessNumber.useMutation();
  const current = useRef({ number: businessNumber, version: 0, request: 0 });
  if (current.current.number !== businessNumber) {
    current.current = { number: businessNumber, version: current.current.version + 1, request: 0 };
  }
  const [result, setResult] = useState<{
    number: string;
    version: number;
    state: BusinessNumberState | null;
    isPending: boolean;
  } | null>(null);
  const check = async (): Promise<void> => {
    if (!/^\d{10}$/.test(businessNumber)) return;
    const version = current.current.version;
    const request = ++current.current.request;
    setResult({ number: businessNumber, version, state: null, isPending: true });
    let state: BusinessNumberState = 'UNKNOWN';
    try {
      state = (await mutation.mutateAsync({ businessNumber })).state;
    } catch {
      /* 조회 실패는 주문을 막지 않는다. 서버가 제출 시 재조회한다. */
    }
    if (
      current.current.number === businessNumber &&
      current.current.version === version &&
      current.current.request === request
    ) {
      setResult({ number: businessNumber, version, state, isPending: false });
    }
  };
  const matches = result?.number === businessNumber && result?.version === current.current.version;
  return {
    check,
    state: matches ? result.state : null,
    isPending: matches ? result.isPending : false,
  };
};
